class YoutubeBanner {
  constructor (data) {
    this.id = data ? data.id : ''
    this.image = data ? data.image : ''
    this.imageUrl = data ? data.imageUrl : ''
    this.is_homepage_banner = data ? data.is_homepage_banner === 1 : true
    this.created_at = data ? data.created_at : ''
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('image', this.image)
    formData.append('is_homepage_banner', this.is_homepage_banner === true ? 1 : 0)
    return formData
  }
}

export default YoutubeBanner



// WEBPACK FOOTER //
// ./src/models/YoutubeBanner.js